import {Box} from '@chakra-ui/react';
import {ChevronRight} from 'lucide-react';

interface HoverableChevronProps {
  strokeWidth?: number;
  height?: number;
  defaultColor?: string;
  hoverColor?: string;
  parentHoverClass?: string;
}

const HoverableChevron = ({
  strokeWidth = 2,
  height = 18,
  defaultColor = '#D1D1D1',
  hoverColor = 'black',
  parentHoverClass = '.sidebar-item-content:hover',
}: HoverableChevronProps) => {
  return (
    <Box
      sx={{
        color: defaultColor,
        transition: 'color 0.2s',
        [`${parentHoverClass} &`]: {
          color: hoverColor,
        },
      }}
    >
      <ChevronRight strokeWidth={strokeWidth} height={height} />
    </Box>
  );
};

export default HoverableChevron;
